import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { HashLink } from "react-router-hash-link";
import { IdParts } from "../@types";
import routes from "../app/routes";
import { makePlanLongId } from "../helpers";

interface PlanDetailsHashLinkProps extends RouteComponentProps {
  className?: string;
  label: string;
  onClick?: () => void;
  plan: IdParts;
  section: string;
}

const PlanDetailsHashLink: React.FunctionComponent<PlanDetailsHashLinkProps> = ({
  className,
  label,
  location,
  onClick,
  plan,
  section,
}) => {
  return (
    <HashLink
      className={className || ""}
      onClick={onClick}
      to={`${routes.planDetails.replace(":id", makePlanLongId(plan))}${
        location.search
      }#${section}`}
      scroll={(el): void => {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        el.focus();
      }}
    >
      {label}
    </HashLink>
  );
};

export default withRouter(PlanDetailsHashLink);
